import { useMemo } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { CommonUtility, Tabs } from '../../../../../../utility';
import { RouteTabs } from '../../../../../../components';
import { ToteTab } from './tote';
import { SingleTab } from './single';
import { useWavesFilterContext } from '..';

export function SortedWaveListTab() {
  const { pathname } = useLocation();
  const { warehouseId } = useWavesFilterContext();
  const navigate = useNavigate();
  const currentTab = useMemo(() => {
    if (location.pathname) {
      return CommonUtility.getSegmentByPosition(location.pathname, 6);
    }
    return null;
  }, [pathname]);

  const tabClicked = tabName => {
    navigate(`/app/fulfill/waves/list/sorted/${tabName}`);
  };

  const menus = [
    {
      text: 'Tote',
      value: Tabs.WavesTabs.sortedTabs.tote,
    },
    {
      text: 'Ship in Box',
      value: Tabs.WavesTabs.sortedTabs.single,
    },
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <RouteTabs items={menus} activeKey={currentTab} onChange={tabClicked} />
      </div>
      <Routes>
        <Route index element={<Navigate to="tote" />} />
        <Route path="tote" element={<ToteTab warehouseId={warehouseId} />} />
        <Route path="single" element={<SingleTab warehouseId={warehouseId} />} />
      </Routes>
    </div>
  );
}
